namespace Gamification.Gamification {
    export interface ChecklistRow {
        IdChecklist?: number;
        Nome?: string;
        UserId?: number;
        TenantId?: number;
        IdAssetEsperienza?: number;
        Progressivo?: number;
        IdAssetEsperienzaNome?: string;
    }

    export namespace ChecklistRow {
        export const idProperty = 'IdChecklist';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Checklist';
        export const lookupKey = 'Gamification.Checklist';

        export function getLookup(): Q.Lookup<ChecklistRow> {
            return Q.getLookup<ChecklistRow>('Gamification.Checklist');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdChecklist = "IdChecklist",
            Nome = "Nome",
            UserId = "UserId",
            TenantId = "TenantId",
            IdAssetEsperienza = "IdAssetEsperienza",
            Progressivo = "Progressivo",
            IdAssetEsperienzaNome = "IdAssetEsperienzaNome"
        }
    }
}
